import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/Webcast2025InReviewWithMikeStonebrakerAndAndyPavloPage.head';
import { Webcast2025InReviewWithMikeStonebrakerAndAndyPavloPage } from '@pages/Webcast2025InReviewWithMikeStonebrakerAndAndyPavloPage';

export const Route = createFileRoute('/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo')({
  component: Webcast2025InReviewWithMikeStonebrakerAndAndyPavloPage,
  head: () => head,
});
